import React from "react";
import ViewRentalCarSchedule from "./ViewRentalCarSchedule";

const ViewMaintenanceCarSchedule = () => (
	<ViewRentalCarSchedule mode="maintenance" />
);

export default ViewMaintenanceCarSchedule;
